import { createSlice } from "@reduxjs/toolkit";
import { FirestoreService } from "../../api/firebase/firestoreService";
import { FirestoreCollectionReference } from "../../api/firebase/references";
import { DataState } from "../store/store";

export interface CPTDetails {
  AllowedAmount?: string;
  Benefit?: string;
  CPT?: string;
  Code?: string;
  Description?: string;
}

const initialState: DataState<CPTDetails[]> = {
  loading: false,
  error: null,
  data: null,
};

const cptSlice = createSlice({
  name: "cptSlice",
  initialState,
  reducers: {
    fetchingCPT: (state) => {
      state.loading = true;
    },
    setCPT: (state, action) => {
      state.data = action.payload;
      state.loading = false;
    },
    errorFetchingCPT: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    resetCPT: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const { fetchingCPT, setCPT, errorFetchingCPT, resetCPT } =
  cptSlice.actions;

export const fetchCPTFromFirebase = () => async (dispatch) => {
  dispatch(fetchingCPT());
  const data = FirestoreService.listenToQueryCollection<CPTDetails>(
    FirestoreCollectionReference.cptCode(),
    (docs) => {
      dispatch(setCPT(docs));
    },
    (error) => {
      dispatch(errorFetchingCPT(error));
    },
  );
  return data;
};

export default cptSlice.reducer;
